import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { TTournamentDetailed } from "@smartico/public-api/dist/WSAPI/WSAPITypes"
import { Smartico } from "../../core/Smartico"
import { RootState } from "../store"

// Initial State for Tournament Details Slice
interface TournamentDetailsState {
    details: Record<number, TTournamentDetailed | null>
    error: string | null
}

const initialTournamentDetailsState: TournamentDetailsState = {
    details: {},
    error: null,
}

// Async thunk to fetch tournament details
export const fetchTournamentDetails = createAsyncThunk('tournamentDetails/fetchTournamentDetails', async (tournamentInstanceId: number, { rejectWithValue }) => {
    try {
        const smarticoApi = await Smartico.apiReady
        const tournamentDetail = await smarticoApi.getTournamentInstanceInfo(tournamentInstanceId)
        return { tournamentInstanceId, tournamentDetail }
    } catch (error) {
        return rejectWithValue('Failed to fetch tournament details')
    }
})

// Tournament Details Slice
const tournamentDetailsSlice = createSlice({
    name: 'tournamentDetails',
    initialState: initialTournamentDetailsState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTournamentDetails.pending, (state, action) => {
                const tournamentInstanceId = action.meta.arg;
                state.details[tournamentInstanceId] = null;
                state.error = null;
            })
            .addCase(fetchTournamentDetails.fulfilled, (state, action) => {
                const { tournamentInstanceId, tournamentDetail } = action.payload;
                state.details[tournamentInstanceId] = tournamentDetail;
                state.error = null;
            })
            .addCase(fetchTournamentDetails.rejected, (state, action) => {
                const tournamentInstanceId = action.meta.arg;
                state.details[tournamentInstanceId] = null;
                state.error = action.payload as string;
            })
    },
})

export const selectTournamentDetails = (tournamentInstanceId: number) => (state: RootState) =>
    state.tournamentInfo.details[tournamentInstanceId]

export default tournamentDetailsSlice.reducer